var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHide = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 12,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.678 10.219 8.79-8.438M4.593 9.305c.455.142.93.213 1.406.21 1.922.033 3.872-1.317 5.072-2.643a.774.774 0 0 0 0-1.04 9.4 9.4 0 0 0-1.44-1.295m-1.246-.754A5.3 5.3 0 0 0 6 3.188C4.125 3.155 2.156 4.477.928 5.83a.773.773 0 0 0 0 1.04A9.4 9.4 0 0 0 3.24 8.748m1.355-1.308a1.805 1.805 0 0 1 2.578-2.475m.586 1.388A1.76 1.76 0 0 1 6 8.109"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 12,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m1.678 10.219 8.79-8.438M4.593 9.305c.455.142.93.213 1.406.21 1.922.033 3.872-1.317 5.072-2.643a.774.774 0 0 0 0-1.04 9.4 9.4 0 0 0-1.44-1.295m-1.246-.754A5.3 5.3 0 0 0 6 3.188C4.125 3.155 2.156 4.477.928 5.83a.773.773 0 0 0 0 1.04A9.4 9.4 0 0 0 3.24 8.748m1.355-1.308a1.805 1.805 0 0 1 2.578-2.475m.586 1.388A1.76 1.76 0 0 1 6 8.109"
  }));
});
export default SvgIconHide;
export const raw = __webpack_public_path__ + "static/media/IconHide.f600b67e272c3a82bf69ee07ddc1c224.svg";